var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit3 = function SvgEdit3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "edit-3_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20h9M18 2.879c-.563 0-1.102.223-1.5.621L4 16l-1 4 4-1L19.5 6.5A2.12 2.12 0 0 0 18 2.879Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgEdit3 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTIgMjBIMjEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xOCAyLjg3ODY2QzE3LjQzNzQgMi44Nzg2NiAxNi44OTc4IDMuMTAyMTYgMTYuNSAzLjQ5OTk4TDQgMTZMMyAyMEw3IDE5TDE5LjUgNi40OTk5OEMxOS42OTcgNi4zMDMgMTkuODUzMiA2LjA2OTE1IDE5Ljk1OTggNS44MTE3OEMyMC4wNjY1IDUuNTU0NDEgMjAuMTIxMyA1LjI3ODU2IDIwLjEyMTMgNC45OTk5OEMyMC4xMjEzIDQuNzIxNDEgMjAuMDY2NSA0LjQ0NTU2IDE5Ljk1OTggNC4xODgxOUMxOS44NTMyIDMuOTMwODIgMTkuNjk3IDMuNjk2OTcgMTkuNSAzLjQ5OTk4QzE5LjMwMyAzLjMwMyAxOS4wNjkyIDMuMTQ2NzQgMTguODExOCAzLjA0MDE0QzE4LjU1NDQgMi45MzM1MyAxOC4yNzg2IDIuODc4NjYgMTggMi44Nzg2NloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";